import React, {useEffect, useRef} from "react"

const useEffectOnce = (customFunction: any, deps: any) => {
    const useOnce = useRef(false)
    useEffect(() => {
      if (useOnce.current) {
          return
      } 
      useOnce.current = true
      
      return customFunction()
    }, [...deps]);
  };
  
export default useEffectOnce;